import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { KnowledgeBaseDoc } from '../types';

interface KnowledgeBaseState {
  docs: KnowledgeBaseDoc[];
  currentDoc: KnowledgeBaseDoc | null;
  isLoading: boolean;
  lastFetched: number | null;
}

const initialState: KnowledgeBaseState = {
  docs: [],
  currentDoc: null,
  isLoading: false,
  lastFetched: null,
};

const knowledgeBaseSlice = createSlice({
  name: 'knowledgeBase',
  initialState,
  reducers: {
    setDocs: (state, action: PayloadAction<KnowledgeBaseDoc[]>) => {
      state.docs = action.payload;
      state.lastFetched = Date.now();
      state.isLoading = false;
    },
    setCurrentDoc: (state, action: PayloadAction<KnowledgeBaseDoc | null>) => {
      state.currentDoc = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    addDoc: (state, action: PayloadAction<KnowledgeBaseDoc>) => {
      state.docs.unshift(action.payload);
    },
    updateDoc: (state, action: PayloadAction<KnowledgeBaseDoc>) => {
      const idx = state.docs.findIndex((d) => d._id === action.payload._id);
      if (idx !== -1) state.docs[idx] = action.payload;
      if (state.currentDoc?._id === action.payload._id) state.currentDoc = action.payload;
    },
    removeDoc: (state, action: PayloadAction<string>) => {
      state.docs = state.docs.filter((d) => d._id !== action.payload);
      if (state.currentDoc?._id === action.payload) state.currentDoc = null;
    },
  },
});

export const { setDocs, setCurrentDoc, setLoading, addDoc, updateDoc, removeDoc } =
  knowledgeBaseSlice.actions;

export default knowledgeBaseSlice.reducer;
